import {
    forwardRef
} from "react";
import {
    Pressable,
    Platform,
    View
} from "react-native";
import type ICarouselThumbnailProps from "./type";
import type {
    CarouselThumbnailWebPropsType
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import StateLayer from "../../../stateLayer";

const CarouselThumbnail = forwardRef<View, ICarouselThumbnailProps>(({
    customTheme,
    isSelected,
    onHoverOut,
    onPressOut,
    onHoverIn,
    onKeyDown,
    onPressIn,
    children,
    onFocus,
    onPress,
    onBlur,
    label,
    ...props
}, ref) => {
    const {
        controlHeights,
        shapeConfigs,
        radiuses,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState({
        onHoverOut,
        onPressOut,
        onHoverIn,
        onPressIn,
        onFocus,
        onBlur
    });

    const {
        container: containerDynamicStyle,
        media: mediaDynamicStyle,
        ring: ringDynamicStyle,
        gap: gapDynamicStyle
    } = useStyles({
        controlHeights,
        isFocusVisible,
        shapeConfigs,
        radiuses,
        borders,
        colors,
        spaces
    });

    const webProps: CarouselThumbnailWebPropsType = Platform.OS === "web" ? {
        onKeyDown
    } : {};

    return <Pressable
        {...props}
        {...interactionHandlers}
        {...webProps}
        tabIndex={isSelected ? 0 : -1}
        aria-selected={isSelected}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-label={label}
        onPress={onPress}
        role="tab"
        ref={ref}
    >
        <View
            style={[
                stylesheet.media,
                mediaDynamicStyle
            ]}
        >
            {children}
        </View>
        <View
            style={stylesheet.layer}
        >
            <StateLayer
                borderRadius={radiuses.form}
                customTheme={customTheme}
                overlayColor="default"
                isHovered={isHovered}
                isPressed={isPressed}
            />
            {
                isSelected ?
                    <View
                        style={[
                            stylesheet.ring,
                            ringDynamicStyle
                        ]}
                    >
                        <View
                            style={[
                                stylesheet.gap,
                                gapDynamicStyle
                            ]}
                        />
                    </View>
                :
                    null
            }
        </View>
    </Pressable>;
});

CarouselThumbnail.displayName = "CarouselThumbnail";
export default CarouselThumbnail;
